import {Button, Col, Row, Tag} from "antd";
import Content from "./content";

const Package = ({namePackage, propose, money, pay, textButton, text3, text4 })=>{

    return (
        <Col span={8}
             className={"text-start"}
        >
            <div style={{
                border: "1px solid #EAECF0",
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                borderBottomLeftRadius: 16,
                borderBottomRightRadius: 16,
                paddingLeft: 12,
                paddingRight: 12
            }}>
                <Row gutter={24} style={{borderBottom: "1px solid #EAECF0"}}>
                    <Col span={19} style={{padding: "24px 0 12px 24px"}}>
                        <span className={"text-lg font-semibold"}> {namePackage} </span>
                    </Col>
                    {
                        propose && <Col span={5} style={{padding: "24px 0 12px 0"}}>
                            <Tag color="processing"
                                 bordered={false}
                                 style={{
                                     borderRadius: 16,
                                     padding: "4px 12px"
                                 }}
                            > Đề xuất </Tag>
                        </Col>
                    }

                    <Col span={24}
                         style={{padding: "0 0 12px 24px"}}
                         className={"h-[72px] flex items-center"}>
                        <span className={"text-lg font-semibold"}
                              style={{
                                  fontSize: 40
                              }}
                        >
                            {money}
                        </span>
                    </Col>
                    <Col span={24} style={{paddingLeft: 24}}>
                        <span className={"text-lg font-normal"}>
                            {pay}
                        </span>
                    </Col>
                    <Col span={24} style={{padding: 24}}>
                        <Button type={"primary"}
                                style={{
                                    height: 48,
                                    color: "white"
                                }}
                                className={"w-full"}>
                            {textButton}
                        </Button>
                    </Col>
                </Row>

                <Row style={{padding: "24px 12px"}}>
                    <Col span={24} style={{paddingBottom: 24}}>
                        <span className={"text-base font-semibold"}> Tính năng </span>
                    </Col>
                    <Content content={"Truy cập các tính năng cơ bản"} />
                    <Content content={"Báo cáo và phân tích cơ bản"} />
                    <Content content={text3} />
                    <Content content={text4} />
                </Row>
            </div>
        </Col>
    )
}

export default Package
